import { Component, OnInit } from '@angular/core';
import { ContractService } from '../services/contract.service';
import { NotifierService } from 'angular-notifier';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { VersionConfirmationDialogComponent } from '../pop-ups/version-confirmation-dialog/version-confirmation-dialog.component';
import { DiscardConfirmationDialogComponent } from '../pop-ups/discard-confirmation-dialog/discard-confirmation-dialog.component';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrls: ['./contract-details.component.scss']
})
export class ContractDetailsComponent implements OnInit {
  public accessRoles: any;
  public uuid:string='';
  public contractDetails:any={};
  public access:any = {};
  public quoteObj:any = [];
  public selectedVersion:string='';
  public isContractSigned:boolean = false;
  public isValidContract:boolean = false;
  public isDiscard:boolean = false;
  public isSharedWithClient:boolean = false;
  public isShowVersionPopup:boolean = false;
  // public groupedContractDetails:any = {};
  constructor(
    public contractService: ContractService,
    private notifier:NotifierService,
    private router: Router,
    private activaterRoute:ActivatedRoute,
    private dialog: MatDialog
  ) { 
    this.accessRoles = JSON.parse(localStorage.getItem('access'));
    this.uuid = this.activaterRoute.snapshot.params['uuid'];
    this.contractService.onContractDetailsReload
      .subscribe(() => {
        this.selectedVersion = '';
        // console.log("onContractDetailsReload",this.selectedVersion);
        this.getContractQuoteDetails();
      })
  }

  ngOnInit(): void {
    // this.getForm();
    this.getContractQuoteDetails();
  }

  onEditClick(){
    this.contractService.contractSaveId = this.uuid;
    this.contractService.backTrack = "contract-details";
    if(this.isShowVersionPopup){
      this.openVersionChangeConfirmationDialog();
    }else{
      this.router.navigate(['/contract/request/'+this.uuid]);
    }
  }

  onPreviewClick(){
    if(this.contractService.isShowPreview){
      this.contractService.contractSaveId = this.uuid;
      this.contractService.backTrack = "contract-details";
      this.router.navigate(['/contract/preview/'+this.uuid]);
    }else{
      this.notifier.notify('error','Generating a COS of more than 20 lakh is not allowed!');
    }
  }
  onDownloadClick(){}
  onSendForApproval(){
    if(this.contractService.isShowPreview){
      if(this.isValidContract){
        this.contractService.onSendForApproval(this.uuid);
      }else{
        this.notifier.notify('error','Please fill all the mandatory fields!');
      }
    }else{
      this.notifier.notify('error','Generating a COS of more than 20 lakh is not allowed!');
    }
  }
  onShareWithClient(){
    if(this.contractService.isShowPreview){
      if(this.isValidContract){
        let body = {"uuid":this.uuid};
        this.contractService.onShareWithClient(body);
      }else{
        this.notifier.notify('error','Please fill all the mandatory fields!');
      }
    }else{
      this.notifier.notify('error','Generating a COS of more than 20 lakh is not allowed!');
    }
  }

  // getForm() {
  //   let query = this.uuid && this.uuid != "" ?{"uuid":this.uuid} : {};
  //   this.contractService.getContractForm(query).subscribe((result) => {
  //     if (result["status"] == 1) {
  //       this.quoteObj = result['data'];
  //       this.getContractDetails();
  //     }else{
  //       this.notifier.notify('error','Something went wrong !');
  //     }
  //   }, err => {
  //     this.notifier.notify('error','Something went wrong !');
  //   })
  // }

  // getContractDetails() {
  //   this.contractService.getContractDetails(this.uuid).subscribe((result) => {
  //     if (result["status"] == 1) {
  //       let data = result['data'];
  //       this.contractService.cid = result["cid"];
  //       this.reAssignQuoteObj(data);
  //     }else{
  //       this.notifier.notify('error','Something went wrong !');
  //     }
  //   }, err => {
  //     this.notifier.notify('error','Something went wrong !');
  //   })

  // }

  // reAssignQuoteObj(data){
  //   let groupedContractDetails = {}
  //   this.quoteObj.forEach((field,index) => {
  //     groupedContractDetails[field.group_label] = (groupedContractDetails && groupedContractDetails[field.group_label]) ? groupedContractDetails[field.group_label] : {"values": []};
  //     let fieldObj = {"type":field["type"],"key":field["key"],"name":field["label"]};
  //     this.contractService.contractQuoteSavePrevPayloadObject = JSON.stringify(data);
  //     if (Object.keys(data).includes(field["id"] +'')) {
  //       if (field["type"] == 'from-to') {
  //         let selectedValue = (data[field["id"]]["value"] && data[field["id"]]["value"] !="" && typeof data[field["id"]]["value"] === 'string') ? JSON.parse(data[field["id"]]["value"]) : data[field["id"]]["value"];
  //         fieldObj["value"] = (selectedValue && selectedValue.from && selectedValue.to) ? selectedValue.from +' - '+ selectedValue.to : (selectedValue && selectedValue.from) ? selectedValue.from : (selectedValue && selectedValue.to) ? selectedValue.to : "NA";
  //       }else if (field["type"] == 'single-select-obj') {
  //         let selectedValue = (data[field["id"]]["value"] && data[field["id"]]["value"] !="" && typeof data[field["id"]]["value"] === 'string') ? JSON.parse(data[field["id"]]["value"]) : data[field["id"]]["value"];
  //         fieldObj["value"] = (selectedValue && selectedValue.label && selectedValue.label != '') ? selectedValue.label : "NA";
  //       }else if (field["type"] == 'multi-select-obj') {
  //         let selectedValue = (data[field["id"]]["value"] && data[field["id"]]["value"] !="" && typeof data[field["id"]]["value"] === 'string') ? JSON.parse(data[field["id"]]["value"]) : data[field["id"]]["value"];
  //         fieldObj["value"] = (selectedValue && selectedValue.length) ? selectedValue.map(item => {return item.label}) : "NA";
  //       }else if (field["type"] == 'multi-select') {
  //         let selectedValue = (data[field["id"]]["value"] && data[field["id"]]["value"] !="" && typeof data[field["id"]]["value"] === 'string') ? JSON.parse(data[field["id"]]["value"]) : data[field["id"]]["value"];
  //         fieldObj["value"] = (selectedValue && selectedValue.length) ? selectedValue : "NA";
  //       }else if (field["type"] == 'percent-term') {
  //         let selectedValue = (data[field["id"]]["value"] && data[field["id"]]["value"] !="" && typeof data[field["id"]]["value"] === 'string') ? JSON.parse(data[field["id"]]["value"]) : data[field["id"]]["value"];
  //         fieldObj["value"] = (selectedValue && selectedValue.length) ? selectedValue.map(item => {return item.percent + ' ('+ item.term+') '}) : "NA";
  //       }else{
  //         fieldObj["value"] = (data[field["id"]]["value"] && data[field["id"]]["value"] != '') ? data[field["id"]]['value'] : "NA";
  //       }
  //     }else{
  //       fieldObj["value"] = "NA";
  //     }
  //     groupedContractDetails[field.group_label]["values"].push(fieldObj);
  //   });
  //   this.contractDetails = groupedContractDetails;
  //   console.log("groupedContractDetails",this.contractDetails);
  // }

  getContractQuoteDetails(){
    this.contractService.getContractQuoteDetails(this.uuid,this.selectedVersion).subscribe((result) => {
      if (result["status"] == 1) {
        this.contractDetails = result['data'];
        this.access = result['access'];
        this.contractService.cid = result["cid"];
        this.isContractSigned = result['signed'] ? result['signed'] : false;
        this.isValidContract = result['is_valid_form'] ? result['is_valid_form'] : false;
        // this.contractService.contractVersionList = result['versions'];
        this.isSharedWithClient = result['shared_with_client'] ? result['shared_with_client'] : false;
        this.isShowVersionPopup = result['is_show_version_popup'] ? result['is_show_version_popup'] : false;
        this.contractService.contractVersionList = result['versions'].map((item) => item +'');
        this.isDiscard = result["discard"] ? result["discard"] : false;
        this.contractService.isShowPreview = result['show_preview'] ? result['show_preview'] : false;
        this.selectedVersion = this.selectedVersion && this.selectedVersion !="" ? this.selectedVersion : result['versions'][0] +'';
      }else{
        this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }

  onVersionChange(version){
    this.selectedVersion = version;
    this.getContractQuoteDetails();
  }

  // onDiscardContractChanges(){
  //   let body = {"uuid":this.uuid,"version":this.selectedVersion};
  //   this.contractService.onDiscardContractVersion(body).subscribe((result) => {
  //     if (result["status"] == 1) {
  //       this.notifier.notify('success','Version removed successfully!');
  //     }else{
  //       this.notifier.notify('error','Something went wrong !');
  //     }
  //   }, err => {
  //     this.notifier.notify('error','Something went wrong !');
  //   })
  // }

  openVersionChangeConfirmationDialog(): void {
    const dialogRef = this.dialog.open(VersionConfirmationDialogComponent, {
      width: '500px',
      height: '250px',
      disableClose :true,
      data:{
        cid:this.contractService.cid,
        uuid:this.uuid
      }
    });
  }

  openDiscardConfirmationDialog(): void {
    const dialogRef = this.dialog.open(DiscardConfirmationDialogComponent, {
      width: '500px',
      height: '250px',
      disableClose :true,
      data:{
        cid:this.contractService.cid,
        uuid:this.uuid,
        selectedVersion:this.selectedVersion
      }
    });
  }

}
